module.exports = __webpack_public_path__ + "img/pipeline_en.79337ef8.jpg";